document.addEventListener("DOMContentLoaded", function(e) {
    // Usage of the IoNav
    let ionav = new IoNav({
        buttonElement: document.querySelector("#burger-menu"),
        overlayTarget: document.querySelector("#burger-menu"),
        elements: ".header-logo img,.nav-main,.menu-language",
        elementsNav: "EMPTY",
        linkSubmenuClickable: true,
        activeClassToggleOthers: true, // Only one active element is possible at the same time
        mqlQuery: {
            minWidth: "0px",
            maxWidth: "1279px"
        },
        debug: false
    });
});
